import React, { Component } from "react";
import * as Constants from "../../../common/Global/constants";
import { AddNewButtonLayout, SearchSpan, TableRadioButton } from "../../../common/Global/globalStyles.style";
import Sidebar from "../../../common/SidebarCollapse";
import Topbar from "../../../common/Topbar";
import MasterMenuTabs from "../Common/topmenu";
import TableDropDown from "../../../common/DropdownMenus/TableDropdown";
import AlertDialog from "../../../common/AlertDialog";
import Pagination from "../../../common/Global/pagination";
import {
	getLocalStorageVariables,
	getThemeSettingsVariables,
	isEmptyVariable,
	sortTable,
	isEmptyArray,
	GetOrderedMasterTabMenuExecute,
	handleTokenExpiry,
	getSettingStatus,
	hasFeatureAccess,
	getOnlyFileNameFromPath,
} from "../../../common/Global/commonFunctions";
import { BrowserRouter as Router } from "react-router-dom";
import SelectDocumentDialog from "./selectDocument"; 
import DocumentSamplesListLayout from "./modalListDocumentSample";
import ReviewCommentsDialog from "./reviewCommentsdialog";
import ReviewHistoryDialog from './reviewhistorydialog';
import TopmenuReports from "../../../common/TopmenuReports";
import FilterDropDown from "../../../common/DropdownMenus/FilterDropdown";


const sortDocumentName = "d.name";
const sortDocumentType = "d.documentType";

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();

class SampleCheckedList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			assignmentId: this.props.match.params.id,
			user: {},
			componentDidMountFlag: false,
			apiSearchKey: "",
			searchkey: "",
			currentPageNo: 1,
			showLoader: false,
			resultSize: Constants.RESULT_SIZE,
			totalCount: 0,
			datalist: [],
			statusPlaceholder: "Active",
			resultSizePlaceholder: Constants.RESULT_SIZE ,
			sort: "",
			sortDir: "",
			assignmentStatus: "",
			assignmentDetails: "",
			departmentId: "",
			company:{},

			//new Document
			showSelectDocumentDialog: false,
			selectedDocumentObjArr: [],
			document_NR: "",

			showAlertDialog: false,
			operationType: "",
			deleteReactivateId: "",
			deleteReactivateMasterType: "",
			reviewLevel: "",
			alertDialogMessage: "",
			alertDialogHeading: "",
			proceedBtnLabel: "",

			showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
			
			//sample document
			// showDocumentSamplesListing: false,
			selectedDocumentId: "",
			selectedDocumentName: "",
			showSampleDocumentDialog:false,

			showReviewCommentsDialog: false,
			resultSizeArr: Constants.RESULT_SIZE_DD_ARR,
			allSettings:[],
			auditType:"",
			isSampleCheckedScreen:false,
            isAuditeeScreen:false,
            isTimelineScreen:false,
            isGeneralScreen:false
		};
		this.previousValues = {};
		this.editableRefs = {};
		userDetails = getLocalStorageVariables();
		themeSettings = getThemeSettingsVariables();
	}

	componentDidMount() {
		this.getInitData();
	}

	handleChange = (e) => {
		const { name, value } = e.target;

		let FormErrorsTemp = this.state.formErrors;

		this.setState({
			[name]: value,
			formErrors: FormErrorsTemp,
		});
	};

	handleSelection = (e) => {
		// e.stopPropagation();

		let isChecked = e.target.checked;
		// Sample: 1:-:notReceived
		let name = e.target.name;
		let arr = name.split(":-:");
		let datalistTemp = this.state.datalist;
		let index = arr[0];
		let attrName = arr[1];
		
		const columnNameMap = {
			notReceived: "Not Received",
			partReceived: "Partly Received",
			received: "Received",
			verified: "Verified",
			notApplicable: "N/A"
		};
		const statusArr = ["notReceived", "partReceived", "received", "verified", "notApplicable"];
		const currentStatusKey = statusArr.find(s => datalistTemp[index][s] === "Y") || "notReceived";
		const currentStatus = columnNameMap[currentStatusKey] || currentStatusKey;
		const newStatus = columnNameMap[attrName];
		const documentName = datalistTemp[index].name;
		this.setState({
			pendingSelection: { index, attrName, isChecked },
			alertDialogMessage: `Do you want to change the status of ${documentName} from ${currentStatus} to ${newStatus}?`,
			showAlertDialog: true,
			proceedBtnLabel: "Yes",
			alertDialogHeading: "",
			operationType: "changeSelection"
		});
	};

	handleRecordOperation = () => {
		if (this.state.operationType === "changeSelection" && this.state.pendingSelection) {
			const { index, attrName, isChecked } = this.state.pendingSelection;
			const assignmentSampleCheckedId = this.state.datalist[index].assignmentSampleCheckedId;

			const statusArr = ["notReceived", "partReceived", "received", "verified", "notApplicable"];
			const currentStatusIdx = statusArr.findIndex(s => this.state.datalist[index][s] === "Y");
        	const newStatusIdx = statusArr.indexOf(attrName);

			// Only require review comment if moving from right to left (higher to lower)
			if (newStatusIdx < currentStatusIdx) {
				this.setState({
					showAlertDialog: false,
					showReviewCommentsDialog: true,
					deleteReactivateId: assignmentSampleCheckedId,
				});
			}else {
				// Directly change the value and save
				let datalistTemp = [...this.state.datalist];
				datalistTemp[index].notReceived = "N";
				datalistTemp[index].partReceived = "N";
				datalistTemp[index].received = "N";
				datalistTemp[index].verified = "N";
				datalistTemp[index].notApplicable = "N";
				if (isChecked) {
					datalistTemp[index][attrName] = "Y";
				}
				this.setState({
					datalist: datalistTemp,
					pendingSelection: null,
					operationType: "",
					showAlertDialog: false,
					deleteReactivateId: "",
				}, () => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
		} else if (this.state.operationType === "Delete") {
			const idToDelete = this.state.deleteReactivateId;
			this.setState({ 
				showAlertDialog: false, 
				operationType: "", 
				deleteReactivateId: "" 
			}, () => {
				this.deleteSampleChecked(idToDelete);
			});
		} else {
			this.setState({ showAlertDialog: false });
		}
	}

	handleBlurSampleList = (index, e) => {
		const value = e.currentTarget.textContent;
		let datalistTemp = this.state.datalist;

		if (datalistTemp[index].sampleList + "" !== value) {
			datalistTemp[index].sampleList = value;
			this.setState(
				{
					datalist: datalistTemp,
				},
				() => {
					this.handleSaveProperties(this.state.datalist[index]);
				}
			);
		}
	};

	// Add this method to your class:
	handleNumericInput = (e) => {
		const el = e.currentTarget;
		const value = el.textContent;
		const selection = window.getSelection();
		const range = selection.getRangeAt(0);
		const cursorOffset = range.startOffset;

		// Remove all non-numeric except dot
		let cleaned = value.replace(/[^0-9.]/g, '');

		// Only allow one dot
		if ((cleaned.match(/\./g) || []).length > 1) {
			cleaned = cleaned.replace(/\.+$/, '');
		}
		if (value !== cleaned) {
			el.textContent = cleaned;

			// Move caret to end safely
			requestAnimationFrame(() => {
				const range = document.createRange();
				range.selectNodeContents(el);
				range.collapse(false); // false = move to end
				const sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range);
			});
		}
		// Update state
		const idx = parseInt(el.dataset.idx, 10);
		const field = el.dataset.field;

		if (!isNaN(idx) && field) {
			const datalist = [...this.state.datalist];
			datalist[idx][field] = cleaned;
			this.setState({ datalist });
		}
	};

	preventEnterKey = (e) => {
		if (e.key === "Enter") {
			e.preventDefault(); // Prevent new line
		}
	};

	setCaretToEnd = (el) => {
		if (!el) return;
		const range = document.createRange();
		const sel = window.getSelection();
		range.selectNodeContents(el);
		range.collapse(false); // Move to end
		sel.removeAllRanges();
		sel.addRange(range);
	};

	handleBlurSizeNumber = (index, e) => {
		if (this.isClearingField) return; // prevent duplicate save
		const value = e.currentTarget.textContent.trim();
		let datalistTemp = this.state.datalist;
		const prevValue = this.previousValues[`${index}-totalSizeNumber`] || "";

		// Allow blank value
		if (value === "") {
			if (prevValue !== "") {
				datalistTemp[index].totalSizeNumber = "";
				this.setState({ datalist: datalistTemp }, () => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
			return;
		}
		// Validate number if not empty
		if (isNaN(Number(value))) {
			e.currentTarget.textContent = this.state.datalist[index].totalSizeNumber;
			return;
		}
		const totalNumber = parseInt(value);
		const sampleNumber = parseInt(datalistTemp[index].sampleCheckedNumber);

		if (totalNumber < sampleNumber) {
			this.setState({
				showAlertDialogInfo: true,
				alertDialogMessageInfo: "Total Number should be more than or equal to Sample Number.",
			});
			e.currentTarget.textContent = datalistTemp[index].totalSizeNumber;
			return;
		}
		if (prevValue !== value) {
			datalistTemp[index].totalSizeNumber = value;
			this.setState({
				datalist: datalistTemp,
			}, () => {
				this.handleSaveProperties(this.state.datalist[index]);
			});
		}
	};

	handleBlurSizeValue = (index, e) => {
		if (this.isClearingField) return; // prevent duplicate save
		const value = e.currentTarget.textContent.trim();
		let datalistTemp = [...this.state.datalist];
		const prevValue = this.previousValues[`${index}-totalSizeValue`] || "";

		// Allow blank value
		if (value === "") {
			if (prevValue !== "") {
				datalistTemp[index].totalSizeValue = "";
				this.setState({ datalist: datalistTemp }, () => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
			return;
		}
		// Validate number if not empty
		if (isNaN(Number(value))) {
			e.currentTarget.textContent = this.state.datalist[index].totalSizeValue;
			return;
		}
		const totalValue = parseFloat(value);
		const sampleValue = parseFloat(datalistTemp[index].sampleCheckedValue);

		if (totalValue < sampleValue) {
			this.setState({
				showAlertDialogInfo: true,
				alertDialogMessageInfo: "Total Value should be more than or equal to Sample Value.",
			});
			e.currentTarget.textContent = datalistTemp[index].totalSizeValue;
			return;
		}
		if (prevValue !== value) {
			datalistTemp[index].totalSizeValue = value;
			this.setState({
				datalist: datalistTemp,
			}, () => {
				this.handleSaveProperties(this.state.datalist[index]);
			});
		}
	};

	handleBlurCheckedNumber = (index, e) => {
		if (this.isClearingField) return; // prevent duplicate save
		const value = e.currentTarget.textContent.trim();
		let datalistTemp = this.state.datalist;
		const prevValue = this.previousValues[`${index}-sampleCheckedNumber`] || "";

		// Allow blank value
		if (value === "") {
			if (prevValue !== "") {
				datalistTemp[index].sampleCheckedNumber = "";
				this.setState({ datalist: datalistTemp }, () => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
			return;
		}
		// Validate number if not empty
		if (isNaN(Number(value))) {
			e.currentTarget.textContent = this.state.datalist[index].sampleCheckedNumber;
			return;
		}
		const totalNumber = parseInt(datalistTemp[index].totalSizeNumber);
		const sampleNumber = parseInt(value);

		if (sampleNumber > totalNumber) {
			this.setState({
				showAlertDialogInfo: true,
				alertDialogMessageInfo: "Sample Number should not be more than Total Number.",
			});
			e.currentTarget.textContent = datalistTemp[index].sampleCheckedNumber; // revert back
			return;
		}
		if (prevValue !== value) {
			datalistTemp[index].sampleCheckedNumber = value;
			this.setState({
				datalist: datalistTemp,
			}, () => {
				this.handleSaveProperties(this.state.datalist[index]);
			});
		}
	};

	clearField = (index, key) => {
		this.isClearingField = true;

		const datalistTemp = [...this.state.datalist];
		datalistTemp[index][key] = "";
		this.setState({ datalist: datalistTemp }, () => {
			this.handleSaveProperties(datalistTemp[index]);

			// Delay reset of the flag to allow blur to finish
			setTimeout(() => {
				this.isClearingField = false;
			}, 0);
		});
	};

	handleBlurCheckedValue = (index, e) => {
		if (this.isClearingField) return; // prevent duplicate save
		const value = e.currentTarget.textContent.trim();
		let datalistTemp = this.state.datalist;
		const prevValue = this.previousValues[`${index}-sampleCheckedValue`] || "";

		// Allow blank value
		if (value === "") {
			if (prevValue !== "") {
				datalistTemp[index].sampleCheckedValue = "";
				this.setState({ datalist: datalistTemp }, () => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
			return;
		}
		// Validate number if not empty
		if (isNaN(Number(value))) {
			e.currentTarget.textContent = this.state.datalist[index].sampleCheckedValue;
			return;
		}
		const totalValue = parseFloat(datalistTemp[index].totalSizeValue);
		const sampleValue = parseFloat(value);

		if (sampleValue > totalValue) {
			this.setState({
				showAlertDialogInfo: true,
				alertDialogMessageInfo: "Sample Value should not be more than Total Value.",
			});
			e.currentTarget.textContent = datalistTemp[index].sampleCheckedValue; // revert back
			return;
		}
		
		if (prevValue !== value) {
			datalistTemp[index].sampleCheckedValue = value;
			this.setState({
				datalist: datalistTemp,
			}, () => {
				this.handleSaveProperties(this.state.datalist[index]);
			});
		}
	};

	handleAlertDialogClose = () => {
		this.setState({
			showAlertDialog: false,
			alertDialogMessage: "",
		});
	};

	handleAlertDialogCloseInfo = () => {
		this.setState({
			showAlertDialogInfo: false,
			alertDialogMessageInfo: "",
		});
		if(this.state.responseCode === Constants.CODE_ASSIGNMENT_ACCESS_ERROR ||
            this.state.responseCode === Constants.CODE_ASSIGNMENT_SPECIFIC_ACCESS_ERROR){
			this.props.history.push(Constants.URL_EXECUTEASSIGNMENTS);
		}
	};

	// Add new document
	handleSelectDocumentDialogShow = () => {
		// let focusObj = this.handleFocus()
		this.setState({
			showSelectDocumentDialog: true,
		});
	};

	handleSelectDocumentDialogClose = () => {
		this.setState({
			showSelectDocumentDialog: false,
		});
	};
	handleSelectDocumentDialogSaveClose = (selectedDocumentObjArr, document_NR) => {
		this.setState(
			{
				showSelectDocumentDialog: false,
				selectedDocumentObjArr: selectedDocumentObjArr,
				document_NR: document_NR,
			},
			() => {
				let selectedDocumentIds = [];
				selectedDocumentIds = selectedDocumentObjArr.map((item) => item.documentId);

				// Check if the selected documents are already in the datalist
				// If any of the selected documents are already in the datalist, do not add them again
				let selectedDatalistDocumentIds = [];
				selectedDatalistDocumentIds = this.state.datalist.map((item) => item.documentId);
				const isDuplicate = selectedDatalistDocumentIds.some(id => selectedDocumentIds.includes(id));
				if (isDuplicate) {
					this.setState({
						showAlertDialogInfo: true,
						alertDialogMessageInfo:"Selection of the same document which is already in the sample list is not allowed"
					})
				}else{
					this.handleAddNewSampleChecked(selectedDocumentIds);
				}
			}
		);
	};

	sortTableLocal = (sortColumn) => {
		let sortObj = sortTable(sortColumn, this.state.sort, this.state.sortDir);

		this.setState(
			{
				sort: sortObj.sortTemp,
				sortDir: sortObj.sortDirTemp,
			},
			() => {
				this.getSampleCheckedList();
			}
		);
	};

	onTableDropDownItemClick = (item, dropdownItem) => {
		if (item.label === "Review Comments") {
			this.setState({
				deleteReactivateId:dropdownItem.assignmentSampleCheckedId,
				showReviewCommentsDialog:true,
				// operationType: item.label,
				// alertDialogHeading: "",
				// proceedBtnLabel: "",
				// deleteReactivateId: dropdownItem.,
				// showAlertDialog: true,
				// alertDialogMessage: ,
			});
		} 
		// else if (item.label === "Review History") {
		// 	this.setState({
		// 	deleteReactivateId:dropdownItem.assignmentSampleCheckedId,
		// 	showReviewHistoryDialog:true,
		// 	});

		// }
		else if (item.label === "Check Format") {
			this.setState({
				selectedDocumentId: dropdownItem.documentId,
				selectedDocumentName: dropdownItem.name,
				showSampleDocumentDialog: true,
			});
		}else if (item.label === "Delete") {
			this.setState({
				deleteReactivateId: dropdownItem.assignmentSampleCheckedId,
				operationType: "Delete",
				showAlertDialog: true,
				alertDialogHeading: "Delete Doc List",
				proceedBtnLabel: "Delete",
				alertDialogMessage: "Are you sure you want to delete Doc List " + dropdownItem.name + "?",
			});
		}
	};

	// show sample document format
	handleSampleDocumentDialogShow = () => {
		// let focusObj = this.handleFocus()
		this.setState({
			showSampleDocumentDialog: true,
		});
	};

	handleSampleDocumentDialogClose = () => {
		this.setState({
			showSampleDocumentDialog: false,
			selectedDocumentId: "",
			selectedDocumentName: "",
		});
	};

	handleReviewCommentsDialogClose = (commentSubmitted = false) =>{
		if(commentSubmitted === true && this.state.pendingSelection){
			const { index, attrName, isChecked } = this.state.pendingSelection;
			let datalistTemp = [...this.state.datalist];

			datalistTemp[index].notReceived = "N";
			datalistTemp[index].partReceived = "N";
			datalistTemp[index].received = "N";
			datalistTemp[index].verified = "N";
			datalistTemp[index].notApplicable = "N";
			if (isChecked) {
				datalistTemp[index][attrName] = "Y";
				
				this.setState({
					datalist: datalistTemp,
					pendingSelection: null,
					operationType: "",
					showReviewCommentsDialog: false,
					deleteReactivateId: "",
				},() => {
					this.handleSaveProperties(this.state.datalist[index]);
				});
			}
		}
        this.setState({
            showReviewCommentsDialog:false,
            deleteReactivateId:"",
			pendingSelection: null,
            operationType: ""
        });
    }

	handleReviewHistoryDialogClose = () =>{
        this.setState({
            showReviewHistoryDialog:false,
            deleteReactivateMasterType:"",
            deleteReactivateId:"",
        });
    }
	
	handleChangeSearch = (e) => {
		const { name, value } = e.target;

		this.setState({
			[name]: value,
		});
	};

	onSearchIconClick = () => {
		this.setState({
			currentPageNo: 1,
		},() => {
			this.getSampleCheckedList();
		});
	};

	onEnterBtnPress = (e) => {
		var code = e.keyCode || e.which;
		if (code === 13) {
			this.setState({
				currentPageNo: 1,
			},() => {
				this.getSampleCheckedList();
			});
		}
	};

	resultSizeDropdownClick = (item, selectedIndex) => {
		let tempArr = this.state.resultSizeArr;
		let placeholder = "";

		for (const [i, value] of tempArr.entries()) {
			if (i === selectedIndex) {
				tempArr[i].isSelected = true;
				placeholder = value.label ;
			} else {
				tempArr[i].isSelected = false;
			}
		}

		this.setState({
			resultSizeArr: tempArr,
			resultSize: item.label,
			resultSizePlaceholder: placeholder,
		},() => {
			this.getSampleCheckedList();
		});
	};
	/*******************API CALLS*******************/
	getInitData = () => {
		this.setState({
			showLoader: true,
		});

		Promise.all([
			fetch(Constants.GetSampleChecked, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					assignmentId: this.state.assignmentId,
					resultsize: this.state.resultSize,
				}),
			}),
			fetch(Constants.GetUserMenu, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
				}),
			}),
			fetch(Constants.GetAssignmentsDetails, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken,
					assignmentId: this.state.assignmentId,
				}),
			}),
		])
			.then(([masterRes, menuRes, assignmentRes]) => {
				return Promise.all([masterRes.json(), menuRes.json(), assignmentRes.json()]);
			})
			.then(([masterRes, menuRes, assignmentRes]) => {
				let datalistTemp = [];
				let totalCountTemp = 0;
				let menusTemp = {};
				let userTemp = {};
				let assignmentStatus = "";
				let assignmentDetails = {};
				let companyTemp = {};
				let departmentId = "";
				let allSettings = [];
				let auditType = "";
				let isSampleCheckedScreen = false;
                let isAuditeeScreen = false;
                let isTimelineScreen = false;
                let isGeneralScreen = false;
				if(handleTokenExpiry(masterRes.responseCode)) return;
				else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
					datalistTemp = masterRes.data.samples;
					totalCountTemp = masterRes.data.totalCount;
				} else {
					this.setState({
						showAlertDialogInfo: true,
						alertDialogMessageInfo: masterRes.responseMessage,
						responseCode: masterRes.responseCode
					})
				}

				if(handleTokenExpiry(menuRes.responseCode)) return;
				else if (menuRes.responseCode === Constants.CODE_SUCCESS) {
					menusTemp = menuRes.data.menus;
					userTemp = menuRes.data.user;
					companyTemp = menuRes.data.company;
					allSettings = menuRes.data.allSettings;
				} else {
					menusTemp = {};
					userTemp = {};
				}

				if(handleTokenExpiry(assignmentRes.responseCode)) return;
				else if (assignmentRes.responseCode === Constants.CODE_SUCCESS) {
					assignmentDetails = assignmentRes.data.assignmentDetails;
					assignmentStatus = assignmentDetails.assignmentStatus;
					departmentId = assignmentDetails.departmentId;
                    auditType = assignmentDetails.auditType;
				} else {
				}
				
				const { assignmentTypeId, rootTemplateId } = assignmentDetails;
				isSampleCheckedScreen = getSettingStatus(allSettings, Constants.DOCLIST, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
				isAuditeeScreen = getSettingStatus(allSettings, Constants.AUDITEE, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
				isTimelineScreen = getSettingStatus(allSettings, Constants.TIMELINE, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
				isGeneralScreen = getSettingStatus(allSettings, Constants.GENERAL, "Y", departmentId, assignmentTypeId, true, rootTemplateId, true);
									
                let menusTemp2 = GetOrderedMasterTabMenuExecute(menusTemp,assignmentDetails.observationTemplateId,isSampleCheckedScreen,assignmentDetails.assignmentLevelTemplateId);
				this.setState({
					componentDidMountFlag: true,
					showLoader: false,
					datalist: datalistTemp,
					totalCount: totalCountTemp,
					menus: menusTemp2,
					user: userTemp,
					company:companyTemp,
					assignmentStatus: assignmentStatus,
					departmentId: departmentId,
					assignmentDetails: assignmentDetails,
					allSettings:allSettings,
					auditType:auditType,
					isSampleCheckedScreen:isSampleCheckedScreen,
                    isAuditeeScreen:isAuditeeScreen,
                    isTimelineScreen:isTimelineScreen,
                    isGeneralScreen:isGeneralScreen
				});
			});
	};

	getSampleCheckedList = () => {
		this.setState({
			showLoader: true,
		});

		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			assignmentId: this.state.assignmentId,
			pageNo: this.state.currentPageNo,
			search: this.state.searchkey,
			resultsize: this.state.resultSize,
			// status: this.state.status,
			sort: this.state.sort,
			sortDir: this.state.sortDir,
		};

		fetch(Constants.GetSampleChecked, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					this.setState({
						showLoader: false,
						datalist: data.data.samples,
						totalCount: data.data.totalCount,
					});
				} else {
					this.setState({
						datalist: [],
						showLoader: false,
						totalCount: 0,
						showAlertDialogInfo: true,
						alertDialogMessageInfo: data.responseMessage,
						responseCode: data.responseCode
					});
				}
			});
	};

	onChangePage = (page) => {
		// update state with new page of items
		if (page !== this.state.currentPageNo) {
			this.setState({
				showLoader: true,
			});

			let postParam = {
				email: userDetails.email,
				accessToken: userDetails.accessToken,
				pageNo: page,
				search: this.state.searchkey,
				resultsize: this.state.resultSize,
				// status:this.state.status,
				sort: this.state.sort,
				sortDir: this.state.sortDir,
			};

			fetch(Constants.GetSampleChecked, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams(postParam),
			})
				.then((response) => {
					return response.json();
				})
				.then((data) => {
					if(handleTokenExpiry(data.responseCode)) return;
					else if (data.responseCode === Constants.CODE_SUCCESS) {
						this.setState({
							showLoader: false,
							datalist: data.data.samples,
							totalCount: data.data.totalCount,
							apiSearchKey: this.state.searchkey,
							currentPageNo: page,
						});
					} else {
						this.setState({
							datalist: [],
							showLoader: false,
							apiSearchKey: this.state.searchkey,
							showAlertDialogInfo: true,
							alertDialogMessageInfo: data.responseMessage,
							responseCode: data.responseCode
						});
					}
				});
		}
	};

	handleSaveProperties = (dataListObj) => {
		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			assignmentId: this.state.assignmentId,
			samples: JSON.stringify([dataListObj]),
		};

		fetch(Constants.SaveSampleCheckedProperties, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					this.setState({}, () => {
						this.getSampleCheckedList();
					});
				} else {
					this.setState({
						showAlertDialogInfo: true,
						alertDialogMessageInfo: data.responseMessage,
					});
				}
			});
	};

	handleAddNewSampleChecked = (selectedDocumentIds) => {
		let postParam = {
			email: userDetails.email,
			accessToken: userDetails.accessToken,
			assignmentId: this.state.assignmentId,
			documentIds: JSON.stringify(selectedDocumentIds),
		};

		fetch(Constants.AddNewSampleChecked, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams(postParam),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if(handleTokenExpiry(data.responseCode)) return;
				else if (data.responseCode === Constants.CODE_SUCCESS) {
					this.getSampleCheckedList();
				} else {
				}
			});
	};

	deleteSampleChecked = (assignmentSampleCheckedId) => {
		this.setState({ showLoader: true });

		fetch(Constants.DeleteSampleChecked, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams({
				email: userDetails.email,
				accessToken: userDetails.accessToken,
				assignmentSampleCheckedId: assignmentSampleCheckedId,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				if (handleTokenExpiry(data.responseCode)) return;
				if (data.responseCode === Constants.CODE_SUCCESS) {
					this.setState({
						showLoader: false,
						deleteReactivateId: "",
						operationType: "",
					}, () => {
						this.getSampleCheckedList();
					});
				} else {
					this.setState({
						showLoader: false,
						showAlertDialogInfo: true,
						alertDialogMessageInfo: data.responseMessage,
					});
				}
			});
	};

	downloadSampleCheckedReport = () => {
		this.setState({ showLoader: true });
		fetch(Constants.DownloadSampleCheckedReport, {
			method: "POST",
			mode: "cors",
			body: new URLSearchParams({
				email: userDetails.email,
				accessToken: userDetails.accessToken,
				assignmentId: this.state.assignmentId,
				assignmentStatus: this.state.assignmentStatus,
			}),
		})
		.then((response) => response.json())
		.then((data) => {
			if (data.responseCode !== undefined) {
				if (handleTokenExpiry(data.responseCode)) return;
				this.setState({
					showLoader: false,
					showAlertDialogInfo: true,
					alertDialogMessageInfo: data.responseMessage,
				});
			} else if (data.type === "Buffer" && Array.isArray(data.data)) {
				const uint8Array = new Uint8Array(data.data);
				const blob = new Blob([uint8Array], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});
				const url = URL.createObjectURL(blob);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "SampleCheckedReport.xlsx");
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(url);
				this.setState({ showLoader: false });
			} else {
				this.setState({
					showLoader: false,
					showAlertDialogInfo: true,
					alertDialogMessageInfo: "Failed to download report.",
				});
			}
		})
		.catch(() => {
			this.setState({
				showLoader: false,
				showAlertDialogInfo: true,
				alertDialogMessageInfo: "Failed to download report.",
			});
		});
	};

	downloadAttachment = (documentPath,e) => {
		e.stopPropagation();
		fetch(Constants.API_SERVER_PATH+documentPath)
		.then(response => {
			return response.blob();
		})
		.then(blob => {
			let fileName = getOnlyFileNameFromPath(documentPath);
			const link = document.createElement('a');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('download', fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		});
	}
	/*******************API CALLS END HERE*******************/

	render() {
		let actionArr = [
			{
				icon: "chat",
				label: "Review Comments",
			},
			// {
			// 	icon: "history",
			// 	label: "Review History",
			// },
			{
				icon: "check_circle",
				label: "Check Format",
			},
		];
		if(!hasFeatureAccess(Constants.FEATURE_DOCUMENT_SAMPLES)){
			actionArr = actionArr.filter(item => item.label !== "Check Format")
		}
		return (
			<Router>
				<main className="main-dashboard">
					<section className="dashboard-bg">
						<Sidebar />

						<div className="dashboard-right-bg-collpase">
							<div className="dashboard-wrapper">
								<Topbar />
								{
                                    this.state.componentDidMountFlag && (
                                    <div className="d-flex align-items-center">
                                        <div className="flex-fill">
                                            <MasterMenuTabs
                                                assignmentId={this.state.assignmentId}
                                                masterMenus={this.state.menus}
                                                themeSettings={themeSettings}
												auditType={this.state.auditType}
												isSampleCheckedScreen={this.state.isSampleCheckedScreen}
                                                isAuditeeScreen={this.state.isAuditeeScreen}
                                                isTimelineScreen={this.state.isTimelineScreen}
                                                isGeneralScreen={this.state.isGeneralScreen}
                                            />
                                        </div>
                                        <div>
                                            <TopmenuReports
                                                assignmentId={this.state.assignmentId}
                                                userDetails ={userDetails}
                                                themeSettings={themeSettings}
                                                company={this.state.company}
												allSettings={this.state.allSettings}
                                            />
                                        </div>
                                    </div>
                                )}
								{this.state.showLoader && (
									<div class="loader"></div>
								)}
								<div className="search-addnew-bg">
									<div className="search-addnew">
										<div className="search-filter-layout">
											<FilterDropDown
												placeholder={this.state.resultSizePlaceholder}
												dropdownArr={this.state.resultSizeArr}
												onDropDownItemClick={this.resultSizeDropdownClick}
												themeSettings={themeSettings}
												mleft={0}
											/>
											<div className="search-col m-l-10">
												<input
													name="searchkey"
													type="text"
													onChange={this.handleChangeSearch}
													placeholder="Search"
													onKeyPress={this.onEnterBtnPress}
													value={this.state.searchkey}
												/>
												<SearchSpan themeSettings={themeSettings} onClick={this.onSearchIconClick} className="material-icons">
													{" "}
													search{" "}
												</SearchSpan>
											</div>
										</div>
										<div className="flex-center-layout">
											<span className="tool" data-title="Download Report">
												<AddNewButtonLayout themeSettings={themeSettings}>
													<a onClick={this.downloadSampleCheckedReport} href="javascript:void(0);">
														<span className="material-icons" style={{fontSize:15}}>download</span>
													</a>
												</AddNewButtonLayout>
											</span>
											{!isEmptyVariable(this.state.assignmentStatus) && this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING && (
												<AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:15}}>
													<a onClick={this.handleSelectDocumentDialogShow} href="javascript:void(0);">
														<span className="material-icons">add_circle</span>
														<p>Get Documents</p>
													</a>
												</AddNewButtonLayout>
											)}
										</div>
									</div>
								</div>
								{
									// Need to check component did mount flag, other wise until api is called,
									// it shows no items found layout.
									this.state.componentDidMountFlag && (
										<div className="body-wrapper">
											{!isEmptyArray(this.state.datalist) && (
												<div className="common-tab-bg">
													<div className="common-table" style={{ width: "100%" }}>
														<table className="table height-samplechecked-th">
															<thead>
																<tr className="sample-checked-thead">
																	<th rowSpan="2" className="text-center" width={"5%"}>
																		No.
																	</th>
																	<th rowSpan="2" className="c-pointer" onClick={this.sortTableLocal.bind(this, sortDocumentName)}>
																		<div className="sort-header">
																			Documents
																			<span
																				className={
																					this.state.sort === sortDocumentName ? "material-icons" : "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>	
																		</div>
																	</th>
																	<th rowSpan="2" className="c-pointer" onClick={this.sortTableLocal.bind(this, sortDocumentType)}>
																		<div className="sort-header">
																			Type
																			<span
																				className={
																					this.state.sort === sortDocumentType ? "material-icons" : "material-icons hide-sort-arrow"
																				}
																			>
																				{this.state.sortDir === "asc" ? "arrow_upward" : "arrow_downward"}
																			</span>
																		</div>
																	</th>
																	{/* <th rowSpan="2" className="c-pointer">
																		<div>Sample List</div>
																	</th> */}
																	<th rowSpan="2" className="text-center">
																		<div>Not Received</div>
																	</th>
																	<th rowSpan="2" className="text-center">
																		<div>Partly Received</div>
																	</th>
																	<th rowSpan="2" className="text-center">
																		<div>Received</div>
																	</th>
																	<th rowSpan="2" className="text-center">
																		<div>Verified</div>
																	</th>
																	<th rowSpan="2" className="text-center">
																		<div>N/A</div>
																	</th>
																	<th colSpan="2" className="text-center">
																	{
																		this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING 
																		?
																		<div className="flex-center-layout table-cell-edit just-content"><p>Total Size</p><span className="material-icons">edit</span></div>
																		:
																		<div>Total Size</div>

																	}
																	</th>
																	<th colspan="2" className="text-center">
																	{
																		this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING 
																		?
																		<div className="flex-center-layout table-cell-edit just-content"><p>Doc List</p><span className="material-icons">edit</span></div>
																		:
																		<div>Doc List</div>

																	}
																	</th>
																	<th rowSpan="2" >
																		<div></div>
																	</th>
																</tr>
																<tr className="sample-checked-thead">
																	<th>
																		<div>Value</div>
																	</th>
																	<th>
																		<div>Number</div>
																	</th>

																	<th>
																		<div>Value</div>
																	</th>
																	<th>
																		<div>Number</div>
																	</th>
																</tr>
															</thead>
															<tbody>
																{!isEmptyArray(this.state.datalist) &&
																	this.state.datalist.map((item, idx) => {
																		let isEditable = false;
																		if(!isEmptyVariable(this.state.assignmentStatus) && 
																		this.state.assignmentStatus === Constants.ASSIGNMENT_STATUS_ONGOING){
																			isEditable = true;
																		}
																		return (
																			<tr>
																				<td className="text-center">
																					{(this.state.currentPageNo - 1) * this.state.resultSize + (idx + 1)}
																				</td>
																				<td>{item.name}</td>
																				<td>{item.documentType}</td>
																				{/* <td
																					contenteditable={isEditable?"true":"false"}
																					onBlur={this.handleBlurSampleList.bind(this, idx - 1)}
																					// onKeyPress={this.onEnterBtnPressSampleList.bind(this, idx - 1)}
																				>
																					{item.sampleList}
																				</td> */}
																				<td className="text-center">
																					<TableRadioButton ml={"0px"} themeSettings={themeSettings}>
																						<input
																							type="checkbox"
																							name={idx + ":-:notReceived"}
																							id={idx + "notReceived"}
																							onChange={this.handleSelection}
																							checked={
																								item.notReceived + "" === "Y"
																									? true
																									: isEmptyVariable(item.partReceived) &&
																									  isEmptyVariable(item.received) &&
																									  isEmptyVariable(item.verified) &&
																									  isEmptyVariable(item.notApplicable)
																									? true
																									: false
																							}
																							disabled={isEditable?false:true}
																						/>
																						<label for={idx + "notReceived"} style={{ marginLeft: 6 }}></label>
																					</TableRadioButton>
																				</td>
																				<td className="text-center">
																					<TableRadioButton ml={"0px"} themeSettings={themeSettings}>
																						<input
																							type="checkbox"
																							name={idx + ":-:partReceived"}
																							id={idx + "partReceived"}
																							onChange={this.handleSelection}
																							checked={item.partReceived + "" === "Y" ? true : false}
																							disabled={isEditable?false:true}
																						/>
																						<label for={idx + "partReceived"} style={{ marginLeft: 6 }}></label>
																					</TableRadioButton>
																				</td>
																				<td className="text-center">
																					<TableRadioButton ml={"0px"} themeSettings={themeSettings}>
																						<input
																							type="checkbox"
																							name={idx + ":-:received"}
																							id={idx + "received"}
																							onChange={this.handleSelection}
																							checked={item.received + "" === "Y" ? true : false}
																							disabled={isEditable?false:true}
																						/>
																						<label for={idx + "received"} style={{ marginLeft: 6 }}></label>
																					</TableRadioButton>
																				</td>
																				<td className="text-center">
																					<TableRadioButton ml={"0px"} themeSettings={themeSettings}>
																						<input
																							type="checkbox"
																							name={idx + ":-:verified"}
																							id={idx + "verified"}
																							onChange={this.handleSelection}
																							checked={item.verified + "" === "Y" ? true : false}
																							disabled={isEditable?false:true}
																						/>
																						<label for={idx + "verified"} style={{ marginLeft: 6 }}></label>
																					</TableRadioButton>
																				</td>
																				<td className="text-center">
																					<TableRadioButton ml={"0px"} themeSettings={themeSettings}>
																						<input
																							type="checkbox"
																							name={idx + ":-:notApplicable"}
																							id={idx + "notApplicable"}
																							onChange={this.handleSelection}
																							checked={item.notApplicable + "" === "Y" ? true : false}
																							disabled={isEditable?false:true}
																						/>
																						<label for={idx + "notApplicable"} style={{ marginLeft: 6 }}></label>
																					</TableRadioButton>
																				</td>
																				<td className="editable-td">
																					<div className={`editable-box ${this.state.focusedField  === `${idx}-totalSizeValue` ? 'focused' : ''}`}>
																						<div 
																							className="editable-input"
																							contenteditable={isEditable?"true":"false"}
																							ref={(ref) => { this.editableRefs[`${idx}-totalSizeValue`] = ref }}
																							onInput={this.handleNumericInput}
																							onKeyDown={this.preventEnterKey}
																							onFocus={(e) => {
																								const key = `${idx}-totalSizeValue`;
																								this.setState({ focusedField: key });
																								// Store previous value
																								this.previousValues[key] = e.currentTarget.textContent.trim();
																							}}
																							onBlur={(e) => {
																								this.setState({ focusedField: null });
																								this.handleBlurSizeValue(idx, e)
																							}}>
																								{item.totalSizeValue}
																						</div>
																						{isEditable && 
																							this.state.focusedField === `${idx}-totalSizeValue` && 
																							!isEmptyVariable(item.totalSizeValue) && (
																							<div className="tool clear-tooltip" data-title="Clear">
																								<span 
																									class="material-symbols-outlined eraser-icon" 
																									onMouseDown={() => this.clearField(idx, 'totalSizeValue')}
																								>
																									ink_eraser
																								</span>
																							</div>
																						)}
																					</div>
																				</td>
																				<td className="editable-td">
																					<div className={`editable-box ${this.state.focusedField === `${idx}-totalSizeNumber` ? 'focused' : ''}`}>
																						<div 
																							className="editable-input"
																							contenteditable={isEditable?"true":"false"}
																							ref={(ref) => { this.editableRefs[`${idx}-totalSizeNumber`] = ref }}
																							onInput={this.handleNumericInput}
																							onKeyDown={this.preventEnterKey}
																							onFocus={(e) => {
																								const key = `${idx}-totalSizeNumber`;
																								this.setState({ focusedField: key })
																								this.previousValues[key] = e.currentTarget.textContent.trim();
																							}}
																							onBlur={(e) => {
																								this.setState({ focusedField: null });
																								this.handleBlurSizeNumber(idx, e)
																							}}>
																								{item.totalSizeNumber}
																						</div>
																						{isEditable && 
																							this.state.focusedField === `${idx}-totalSizeNumber` &&
																							!isEmptyVariable(item.totalSizeNumber) && (
																							<div className="tool clear-tooltip" data-title="Clear">
																								<span 
																									class="material-symbols-outlined eraser-icon" 
																									onMouseDown={() => this.clearField(idx, 'totalSizeNumber')}
																								>
																									ink_eraser
																								</span>
																							</div>
																						)}
																					</div>
																				</td>
																				<td className="editable-td">
																					<div className={`editable-box ${this.state.focusedField === `${idx}-sampleCheckedValue` ? 'focused' : ''}`}>
																						<div
																							className="editable-input"
																							contenteditable={isEditable?"true":"false"}
																							ref={(ref) => { this.editableRefs[`${idx}-sampleCheckedValue`] = ref }}
																							onInput={this.handleNumericInput} 
																							onKeyDown={this.preventEnterKey}
																							onFocus={(e) => {
																								const key = `${idx}-sampleCheckedValue`;
																								this.setState({ focusedField: key })
																								this.previousValues[key] = e.currentTarget.textContent.trim();
																							}}
																							onBlur={(e) => {
																								this.setState({ focusedField: null });
																								this.handleBlurCheckedValue(idx, e)
																							}}>
																							{item.sampleCheckedValue}
																						</div>
																						{isEditable && 
																							this.state.focusedField === `${idx}-sampleCheckedValue` &&
																							!isEmptyVariable(item.sampleCheckedValue) && (
																							<div className="tool clear-tooltip" data-title="Clear">
																								<span 
																									class="material-symbols-outlined eraser-icon" 
																									onMouseDown={() => this.clearField(idx, 'sampleCheckedValue')}
																								>
																									ink_eraser
																								</span>
																							</div>
																						)}
																					</div>
																				</td>
																				<td className="editable-td">
																					<div className={`editable-box ${this.state.focusedField === `${idx}-sampleCheckedNumber` ? 'focused' : ''}`}>
																						<div 
																							className="editable-input"
																							contenteditable={isEditable?"true":"false"}
																							ref={(ref) => { this.editableRefs[`${idx}-sampleCheckedNumber`] = ref }}
																							onInput={this.handleNumericInput}
																							onKeyDown={this.preventEnterKey}
																							onFocus={(e) => {
																								const key = `${idx}-sampleCheckedNumber`;
																								this.setState({ focusedField: key })
																								this.previousValues[key] = e.currentTarget.textContent.trim();																							}}
																							onBlur={(e) => {
																								this.setState({ focusedField: null });
																								this.handleBlurCheckedNumber(idx, e)
																							}}>
																								{item.sampleCheckedNumber}
																						</div>
																						{isEditable && 
																							this.state.focusedField === `${idx}-sampleCheckedNumber` &&
																							!isEmptyVariable(item.sampleCheckedNumber) && (
																							<div className="tool clear-tooltip" data-title="Clear">
																								<span 
																									class="material-symbols-outlined eraser-icon" 
																									onMouseDown={() => this.clearField(idx, 'sampleCheckedNumber')}
																								>
																									ink_eraser
																								</span>
																							</div>
																						)}
																					</div>
																				</td>
																				<td className="text-center">
																					<TableDropDown
																						actionArr={[
																							...actionArr,
																							...(item.addedManually === "Y" ? [{ icon: "delete", label: "Delete" }] : []),
																						]}
																						onDropDownItemClick={this.onTableDropDownItemClick}
																						dropDownId={item}
																						dropdownWidth={"150px"}
																						themeSettings={themeSettings}
																					/>
																				</td>
																			</tr>
																		);
																	})}
															</tbody>
														</table>
													</div>
												</div>
											)}
											{this.state.componentDidMountFlag && isEmptyArray(this.state.datalist) && (
												<div class="no-items-layout">
													<div class="no-items-card">
														<h6>
															{isEmptyVariable(this.state.apiSearchKey) ? Constants.NO_RECORDS_WARNING : Constants.EMPTY_SEARCH_WARNING}
														</h6>
													</div>
												</div>
											)}
											<div className="pagination-layout">
												<div className="row custom-row">
													<div className="col-md-9 custom-col">
														{!isEmptyArray(this.state.datalist) && this.state.totalCount > this.state.datalist.length && (
															<Pagination
																totalLength={this.state.totalCount}
																items={this.state.datalist}
																onChangePage={this.onChangePage}
																pageSize={this.state.resultSize}
																currentPageNo={this.state.currentPageNo}
																initialPage={this.state.currentPageNo}
																themeSettings={themeSettings}
															/>
														)}
													</div>
													<div className="col-md-3 custom-col">
														<p>{"Total Records: " + this.state.totalCount}</p>
													</div>
												</div>
											</div>
										</div>
									)
								}
							</div>
						</div>
						<SelectDocumentDialog
							showDocumentDialog={this.state.showSelectDocumentDialog}
							handleSelectDocDialogClose={this.handleSelectDocumentDialogClose}
							handleSelectDocDialogSaveClose={this.handleSelectDocumentDialogSaveClose}
							// selectedDocumentObjArr={this.state.selectedDocumentObjArr}
							// document_NR={this.state.document_NR}
							subscriptionType={this.state.user.subscriptionType}
							departmentId={this.state.departmentId}
							themeSettings={themeSettings}
						/>
						{/* {this.state.showDocumentSamplesListing && ( */}
							<DocumentSamplesListLayout
								showSampleDocumentDialog={this.state.showSampleDocumentDialog}
								handleSampleDocDialogClose={this.handleSampleDocumentDialogClose}
								documentId={this.state.selectedDocumentId}
								documentName={this.state.selectedDocumentName}
								handleBackBtnClickFromSamplesandERP={this.handleBackBtnClickFromSamplesandERP}
								themeSettings={themeSettings}
							/>
						{/* )} */}

						<AlertDialog
							showAlertDialog={this.state.showAlertDialog}
							handleAlertDialogClose={this.handleAlertDialogClose}
							type={Constants.ALERT_TYPE_WARNING}
							alertDialogHeading={this.state.alertDialogHeading}
							alertDialogMessage={this.state.alertDialogMessage}
							proceedBtnClick={this.handleRecordOperation}
							proceedBtnLabel={this.state.proceedBtnLabel}
							themeSettings={themeSettings}
						/>

						<AlertDialog
							showAlertDialog={this.state.showAlertDialogInfo}
							handleAlertDialogClose={this.handleAlertDialogCloseInfo}
							type={Constants.ALERT_TYPE_ALERT}
							alertDialogMessage={this.state.alertDialogMessageInfo}
							proceedBtnClick={this.handleAlertDialogCloseInfo}
							proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
							themeSettings={themeSettings}
						/>

						<ReviewCommentsDialog
							showReviewCommentsDialog={this.state.showReviewCommentsDialog}
							handleReviewCommentsDialogClose={this.handleReviewCommentsDialogClose}
							masterDataId = {this.state.deleteReactivateId}
							assignmentId = {this.state.assignmentId}
							masterType = {"Sample Checked"}
							themeSettings={themeSettings} 
						/>

						<ReviewHistoryDialog
                            showReviewHistoryDialog={this.state.showReviewHistoryDialog}
                            handleReviewHistoryDialogClose={this.handleReviewHistoryDialogClose}
                            masterType = {"Sample Checked"}
                            masterDataId = {this.state.deleteReactivateId}
                        />
					</section>
				</main>
			</Router>
		);
	}
}

export default SampleCheckedList;
